<script>
	import { Table, Col, Button } from "@sveltestrap/sveltestrap";
	import CustomPaginate from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { navigate } from "svelte-routing";
	import { convert } from "../../../services/helpers";
	import {
		carData,
		blackoutCarData,
		carSelection,
		editBlackoutData,
		initialEditBlackout,
	} from "../../../store/store";
	import { onMount } from "svelte";
	import CustomButton from "src/components/CustomButton/CustomButton.svelte";

	export let data = [];

	function handleSave() {
		blackoutCarData.set($carSelection);
		if (!$editBlackoutData.stats) {
			navigate("/blackout-management/create");
		} else {
			navigate(`/blackout-management/edit/${$editBlackoutData.id}`);
			initialEditBlackout.set(1);
		}
	}

	onMount(async () => {
		if ($blackoutCarData) {
			carSelection.set($blackoutCarData);
		}
	});

	function toSelect(option) {
		const already = $carSelection.some((x) => x.id === option.id);
		return already ? $carSelection : [...$carSelection, option];
	}

	function deSelect(option) {
		return $carSelection.filter((x) => x.id !== option.id);
	}
</script>

<div class="d-flex flex-row">
	<Col class="d-flex justify-content-start mt-4 ms-2" xs={6}>
		<div class="mb-2">
			<CustomButton
				class="themeButton"
				on:click={handleSave}
				buttonText="Save"
				disabled={$carSelection.length == 0}
				onKeydown={() => {}}
			/>
		</div>
	</Col>
	<Col class="d-flex justify-content-end mt-4 ms-2" xs={6} />
</div>
<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th
					><div class="form-check">
						<input
							type="checkbox"
							class="form-check-input"
							id="flexCheckDefaultAll"
							on:change={(e) => {
								const currentIds = new Set(
									$carData.map((c) => c.id)
								);
								const othersSelected = $carSelection.filter(
									(c) => !currentIds.has(c.id)
								);
								carSelection.set(
									e.target.checked
										? [...othersSelected, ...$carData]
										: othersSelected
								);
							}}
						/>
						<label
							class="form-check-label"
							for="flexCheckDefaultAll"
						>
							All
						</label>
					</div>
				</th>

				<th>Vehicle No.</th>
				<th>Make</th>
				<th>Model</th>
				<th>Carpark</th>
				<th>Pricing Group</th>
				<th>Active Start Date</th>
				<th>Active End Date</th>
				<th>Status</th>
			</tr>
		</thead>
		<tbody>
			{#each $carData as option, index}
				<tr>
					<td class="align-center">
						<div class="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								value={option}
								checked={$carSelection.some(
									(x) => x.id == option.id
								)}
								on:change={(e) => {
									carSelection.set(
										e.target.checked
											? toSelect(option)
											: deSelect(option)
									);
								}}
								id={`flexCheckDefault-${option.id}`}
								aria-label={`Select car ${option.plateNumber}`}
							/>
						</div>
					</td>

					<td>
						<p>
							<span class="link link-text">
								{option.plateNumber}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span> {option.vehicleMakeName} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {option.vehicleModelName} </span>
						</p>
					</td>
					<td>
						<p>
							<span class="link link-text">
								{option.carParkName}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span> {option.priceGroupName} </span>
						</p>
					</td>
					<td>
						<p>
							<span>{convert(option.activeFrom)} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {convert(option.activeTo)} </span>
						</p>
					</td>
					<td>
						{#if option.status === 1}
							<p class="status-bar status-bar-1">Active</p>
						{:else if option.status === 0}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.totalCount == 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.totalCount} useNavigation />
	<CustomModal />
</LoaderContainer>
